/* eslint-disable import/no-extraneous-dependencies */
import { context, trace } from '@opentelemetry/api';
import { logs, SeverityNumber } from '@opentelemetry/api-logs';

const logger = logs.getLogger('frontend-logger');
const tracer = trace.getTracer('frontend-logger');

function getBrowserMetadata() {
  const timing = performance.getEntriesByType('navigation')[0];

  return {
    hostname: window.location.hostname,
    href: window.location.href,
    userAgent: navigator.userAgent,
    language: navigator.language,
    platform: navigator.platform,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    timing: timing
      ? {
          domComplete: timing.domComplete,
          domContentLoadedEventEnd: timing.domContentLoadedEventEnd,
          domInteractive: timing.domInteractive,
          fetchStart: timing.fetchStart,
          connectStart: timing.connectStart,
          connectEnd: timing.connectEnd,
          domainLookupStart: timing.domainLookupStart,
          domainLookupEnd: timing.domainLookupEnd,
          responseEnd: timing.responseEnd,
          requestStart: timing.requestStart,
          responseStart: timing.responseStart,
        }
      : {},
  };
}

function emit(severityNumber, severityText, body, attrs = {}) {
  const span = trace.getSpan(context.active());
  const browserMetadata = getBrowserMetadata();

  const logAttributes = {
    ...attrs,
    ...browserMetadata,
  };

  if (span) {
    logger.emit({
      body,
      severityNumber,
      severityText,
      attributes: logAttributes,
      context: context.active(),
    });
  } else {
    tracer.startActiveSpan(`log-${severityText}`, (newSpan) => {
      logger.emit({
        body,
        severityNumber,
        severityText,
        attributes: logAttributes,
        context: context.active(),
      });
      newSpan.end();
    });
  }
}

export function logInfo(body, attrs = {}) {
  emit(SeverityNumber.INFO, 'info', body, attrs);
}

export function logWarn(body, attrs = {}) {
  emit(SeverityNumber.WARN, 'warn', body, attrs);
}

export function logError(body, attrs = {}) {
  emit(SeverityNumber.ERROR, 'error', body, attrs);
}
